import React from 'react';
import { Chart } from 'highcharts';
import { connect } from 'react-redux';
import { RootState, StoreProps } from 'store';
import ChartView from './ChartView';
import { ChartViewData } from 'types/Analytics';
import { LayoutTypes } from '../../../editLayout/EditLayout';
import {
  getWlChartStyleTransformer,
  getWlChartOptionsTransformer,
} from 'helpers/wlResolver';

interface ConnectedProps {
  isMenuExpanded: boolean;
  wlId: number | null;
}

interface Props extends StoreProps, ConnectedProps {
  data: ChartViewData;
  withExport?: boolean;
  setRef?: (ref: Chart) => void;
  className?: string;
  layoutType?: LayoutTypes;
  shouldResize: boolean;
}

class ChartViewContainer extends React.Component<Props> {
  render() {
    const {
      data,
      setRef,
      className,
      shouldResize,
      dispatch,
      layoutType,
      isMenuExpanded,
      wlId,
    } = this.props;

    const styleOptions = wlId
      ? (getWlChartStyleTransformer(wlId) ?? undefined)
      : undefined;
    const transformOptions = wlId
      ? (getWlChartOptionsTransformer(wlId) ?? undefined)
      : undefined;

    return (
      <ChartView
        key={'uuid' in data ? data.uuid : ''}
        setRef={setRef}
        data={data}
        className={className}
        shouldResize={shouldResize}
        dispatch={dispatch}
        layoutType={layoutType}
        isMenuExpanded={isMenuExpanded}
        styleOptions={styleOptions}
        transformOptions={transformOptions}
      />
    );
  }
}
const mapStateToProps = (state: RootState): ConnectedProps => ({
  isMenuExpanded: state.layoutConfiguration.isMenuExpanded,
  wlId: state.settings.wlId,
});

export default connect(mapStateToProps)(ChartViewContainer);
